import PndRestApi from "src/utils/pnd/PndRestApi";

const updateHeaderInterceptor = (axiosInstance) => {
    let isRefreshing = false;
    let failedRequestsQueue = [];

    axiosInstance.interceptors.request.use((request) => {
        const isFormData = request?.data instanceof FormData;
        const accessToken = localStorage.getItem('access_token');
        if (accessToken) {
            request.headers['Authorization'] = `Bearer ${accessToken}`;
            if (!isFormData) {
            request.headers['Content-Type'] = 'application/json';
            }
        }
        return request;
    }, (error) => {
        return Promise.reject(error);
    });

    axiosInstance.interceptors.response.use(
        (response) => {
            // Return the response as is if the request is successful
            return response;
        },
        async (error) => {
            const { config } = error;
            const originalRequest = config;
    
            // Check for network error (no response from the server)
            if (!error.response) {
                // Handle network error, show a message, or just log it for now
                console.error('Network Error: No response from the server.');
                
                // Optionally show a message to the user (e.g., in a UI)
                //alert('Network error: Please check your internet connection and try again.');
    
                // If you want to just stay on the same page, return a rejected promise
                return Promise.reject(error); // This will prevent further action, like redirects
            }
    
            // Handle other error scenarios like status code 403, 401, etc.
            if (error.response) {
                const { status } = error.response;
                if (status === 403 && !originalRequest._retry) {
                    if (isRefreshing) {
                        return new Promise((resolve, reject) => {
                            failedRequestsQueue.push({ resolve, reject });
                        }).then((token) => {
                            originalRequest.headers['Authorization'] = `Bearer ${token}`;
                            return axiosInstance(originalRequest);
                        }).catch((err) => {
                            return Promise.reject(err);
                        });
                    }
    
                    originalRequest._retry = true;
                    isRefreshing = true;
    
                    try {
                        // Try refreshing the token if it's expired
                        const response = await PndRestApi.GetRefreshToken();
                        console.log('Refresh token response:', response);
    
                        if (response && response.status === 200 && response.data.status === 200) {
                            const newAccessToken = response?.data?.data?.access_token;
                            localStorage.setItem('access_token', newAccessToken);
                            console.log('New access token stored:', newAccessToken); // Debug log
    
                            isRefreshing = false;
                            failedRequestsQueue.forEach(({ resolve }) => resolve(newAccessToken));
                            failedRequestsQueue = [];
                            originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
                            return axiosInstance(originalRequest);
                        } else {
                            // Handle invalid refresh token or other error responses
                            localStorage.removeItem('access_token');
                            localStorage.removeItem('refresh_token');
                            window.location.href = '/login';
                            throw new Error('Invalid refresh token');
                        }
                    } catch (err) {
                        isRefreshing = false;
                        failedRequestsQueue.forEach(({ reject }) => reject(err));
                        failedRequestsQueue = [];
    
                        if (err.response?.data?.message === 'Invalid refresh token' || err.message === 'Request failed with status code 403') {
                            localStorage.removeItem('access_token');
                            localStorage.removeItem('refresh_token');
                            window.location.href = '/login';
                        }
    
                        return Promise.reject(err);
                    }
                }
            }
        }
    );
    
};

export default updateHeaderInterceptor;
